<template>
    <div>

    </div>
</template>
<script>
    export default {
        name: 'HomePage',
        data() {
            return {
            }
        },
        methods: {},
        mounted() {
        },
        computed: {

        },
    }
</script>

<style scoped>
</style>